/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Component, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {BusinessSettingsModal} from '../business-settings-modal';
import {BusinessSettingsModalState} from '../business-settings-modal.state';
import {WarningModel} from '../../../../api/ms-settings/business/schema/v1/contracts/pool/warning.model';
import {InputListModel} from '../input-list.model';
import {EntityElementModel} from '../../../../shared/entity-tree/entity-element/models/entity-element.model';
import {InputMessagesService} from '../../../../shared/input/service/input-messages.service';
import {WarningsEnum} from '../../../../shared/warnings/warnings.enum';
import {InputTypeEnum} from '../../../../shared/input/input-type.enum';
import {InputTextareaComponent} from '../../../../shared/input/input-textarea/input-textarea.component';
import {MandatoryMessageTypeEnum} from '../../../../shared/input/service/mandatory-message-type.enum';
import {take} from 'rxjs/operators';
import {timer} from 'rxjs';
import { v4 as uuid } from 'uuid';

@Component({
    selector: 'app-warning-modal',
    templateUrl: './warning-modal.component.html',
    styleUrls: ['../business-settings-modal.css', './warning-modal.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WarningModalComponent extends BusinessSettingsModal<BusinessSettingsModalState<WarningModel>> {

    @ViewChild('description') descriptionInput: InputTextareaComponent;

    readonly ENTITY_NAME = 'warning';
    readonly EDIT_TITLE = 'Edit warning';
    readonly ADD_TITLE = 'Add a warning';
    readonly EDIT_SUBMIT_TITLE = 'Edit';
    readonly ADD_SUBMIT_TITLE = 'Add';

    descriptionMessages = new Map<WarningsEnum, string[]>();

    constructor(inputMessages: InputMessagesService) {
        super(inputMessages);
    }

    getInitialData(): void {
        this.storeState({
            currentValue: {
                ...this.state.currentValue,
                code: uuid()
            }
        });
    }

    setEntity(element: EntityElementModel<WarningModel>): void {
        this.storeState({
            originalElement: element,
            originalValue: element.originalValue,
            currentValue: element.currentValue
        });
        this.onReady.pipe(take(1))
.subscribe(() => {
            timer(0)
.subscribe(() => {
                this.descriptionInput.setValue(this.state.currentValue.description);
                this.setActiveInputState(element.active, true);
            });
        });
    }

    mapEntity(): EntityElementModel<WarningModel> {
        return {
            ...super.mapEntity(),
            name: `${this.state.currentValue.description}`,
            displayCode: undefined
        };
    }

    descriptionInputChange(description: string): void {
        this.inputMessages.mandatoryWarnings(this.descriptionInput.inputControl, this.descriptionMessages, MandatoryMessageTypeEnum.SAVE);
        this.inputMessages.invalidInputValueError(
                this.descriptionInput.inputControl,
                this.descriptionMessages,
                this.descriptionInput.label
        );

        this.descriptionMessages = new Map(this.descriptionMessages);

        const errors = this.descriptionMessages.get(WarningsEnum.ERROR);

        this.storeState({
            currentValue: {
                ...this.state.currentValue,
                description
            },
            invalid: {
                ...this.state.invalid,
                description: (description == null || description.length === 0) || (errors != null && errors.length > 0)
            }
        });

        this.setModalValidity();
    }

    protected generateInputs(): InputListModel[] {
        return [{
            input: this.descriptionInput,
            type: InputTypeEnum.TEXTAREA,
            mandatory: true
        }];
    }
}
